import { useMemo } from 'react';
import { DefaultTheme, useTheme } from 'styled-components';

import { EducationalMaterialCategory } from '@dreryk/egabinet-knowledge-base-frontend-api';

import { MessageOptions } from '@dreryk/react-components';

import { dashboardTranslationKeys } from '../../translations';

export const getEducationMaterialTagMessageOptions = (
   theme: DefaultTheme
): MessageOptions<Record<EducationalMaterialCategory, string>> => ({
   FOR_SPECIALIST: {
      color: theme.primary,
      backgroundColor: theme.primaryLighter,
   },
   FOR_PATIENT: {
      color: theme.info,
      backgroundColor: theme.infoLighter,
   },
});

export const useOptions = (): MessageOptions<Record<EducationalMaterialCategory, string>> => {
   const theme = useTheme();
   return useMemo(() => getEducationMaterialTagMessageOptions(theme), [theme]);
};

export const getCategoryLabel = (category: EducationalMaterialCategory): string | undefined => {
   return dashboardTranslationKeys.educationalMaterialCategoryMap?.[category];
};
